import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Contract } from 'src/app/models/entities/contract';
import { ContractType } from 'src/app/models/entities/contract-type';
import { Dealer } from 'src/app/models/entities/dealer';
import { Portal } from 'src/app/models/entities/portal';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { VLogoProject } from 'src/app/models/entities/v-logo-project';
import { VLogoService } from 'src/app/models/entities/v-logo-service';
import { ContractTypeService } from 'src/app/services/contract-type.service';
import { ContractService } from 'src/app/services/contract.service';
import { DealerService } from 'src/app/services/dealer.service';
import { LogoService } from 'src/app/services/logo.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PortalService } from 'src/app/services/portal.service';

@Component({
  selector: 'app-contract-update',
  templateUrl: './contract-update.component.html',
  styleUrls: ['./contract-update.component.css']
})
export class ContractUpdateComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  contractTypes$: Observable<ContractType[]>;
  customers$: Observable<VLogoCustomer[]>;
  services$: Observable<VLogoService[]>;
  projects$: Observable<VLogoProject[]>;
  portals$: Observable<Portal[]>;
  currencyUnits: any[];
  dealers$: Observable<VLogoCustomer[]>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private contractService: ContractService,
    private contractTypeService: ContractTypeService,
    private portalService: PortalService,
    private logoService: LogoService,
    private userService: NbsUserService,
    private dealerService: DealerService
  ) {
    this.currencyUnits = [{ name: "TL" }, { name: "USD" }, { name: "EUR" }]
  }


  ngOnInit(): void {
    this.createForm();
    this.loadDatas();
    this.getContractById();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      contractNumber: [""],
      customerCode: [""],
      portalId: [0],
      dealerId: [0],
      contractTypeId: ["", Validators.required],
      serviceCode: [""],
      projectCode: [""],
      serviceUnitPrice: ["", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      invoiceDate: ["", Validators.required],
      notes: [""],
      currencyUnit: ["TL", Validators.required],
      organizationName: [""],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      customerId: ["", Validators.required],
      serviceId: ["", Validators.required],
      projectId: [0],
      commissionPrice: [0],
      isActive: true
    })
  }

  loadDatas() {
    this.contractTypes$ = this.contractTypeService.getList().pipe(map(result => result.data));
    this.customers$ = this.logoService.getCustomers().pipe(map(result => result.data));
    this.dealers$ = this.logoService.getCustomers().pipe(map(result => result.data.filter(a => a.specodE4 == 'B.01')));
    this.services$ = this.logoService.getServices().pipe(map(result => result.data));
    this.portals$ = this.portalService.getList().pipe(map(result => result.data));
    this.projects$ = this.logoService.getProjects().pipe(map(result => result.data));

  }

  

  getContractById() {
    const contractId = parseInt(this.activatedRoute.snapshot.paramMap.get('contractId'));
    this.contractService.getById(contractId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.form.patchValue({
        id: data.data.id,
        contractNumber: data.data.contractNumber,
        customerCode: data.data.customerCode,
        portalId: data.data.portalId,
        contractTypeId: data.data.contractTypeId,
        serviceCode: data.data.serviceCode,
        projectCode: data.data.projectCode,
        serviceUnitPrice: data.data.serviceUnitPrice,
        commissionPrice: data.data.commissionPrice,
        currencyUnit: data.data.currencyUnit,
        organizationName: "",
        startDate: formatDate(data.data.startDate, 'yyyy-MM-dd', 'en'),
        endDate: formatDate(data.data.endDate, 'yyyy-MM-dd', 'en'),
        invoiceDate: formatDate(data.data.invoiceDate, 'yyyy-MM-dd', 'en'),
        notes: data.data.notes,
        reportTag1: data.data.reportTag1,
        reportTag2: data.data.reportTag2,
        reportTag3: data.data.reportTag3,
        customerId: data.data.customerId,
        serviceId: data.data.serviceId,
        projectId: data.data.projectId,
        dealerId: data.data.dealerId,
        isActive: true
      });
    })
  }

  update() {
    if (this.form.valid) {
      let contract: Contract = this.form.getRawValue();
      contract.portalId = (contract.portalId === null || contract.portalId === undefined) ? 0 : contract.portalId;
      contract.projectId = (contract.projectId === null || contract.projectId === undefined) ? 0 : contract.projectId;
      contract.dealerId = (contract.dealerId === null || contract.dealerId === undefined) ? 0 : contract.dealerId;
      contract.userId = this.userService.getUserId();
      
      this.logoService.getCustomerCodeById(contract.customerId).pipe(takeUntil(this.destroy$)).subscribe(cus => {
        contract.customerCode = cus.data[0].code;
        this.logoService.getServiceCodeById(contract.serviceId).pipe(takeUntil(this.destroy$)).subscribe(ser => {
          contract.serviceCode = ser.data[0].code;
          this.logoService.getProjectCodeById(contract.projectId).pipe(takeUntil(this.destroy$)).subscribe(pro => {
            if (pro.data.length > 0) contract.projectCode = pro.data[0].code; else contract.projectCode = "";
            this.contractService.update(contract).pipe(takeUntil(this.destroy$)).subscribe(
              data => {
                this.toastrService.success(data.message, "Başarılı");
                this.router.navigateByUrl('/contract');
              },
              er => {
                this.toastrService.error(er.error.message, "Hata!");
              }
            );
          })
        })
      })
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }


}
